/**
 * Lease-related models
 */

/**
 * Lease DTO (Response)
 */
export interface LeaseDto {
  id: string;
  customerId: string;
  vesselId: string;
  slipId: string; // For backward compatibility, returns empty string if DryDockLocationId is used
  dryDockLocationId?: string | null; // For dry storage
  status: number;
  termType?: string | null;
  startDate: string;
  endDate?: string | null;
  monthlyRate: number;
  taxRate?: number | null;
  depositAmount: number;
  paymentFrequency?: string | null;
  dueDay?: number | null;
  lateFeePercent?: number | null;
  gracePeriodDays?: number | null;
  renewalNoticeDays?: number | null;
  terminationNoticeDays?: number | null;
  autoRenew: boolean;
  insuranceVerified: boolean;
  stormAddendumSigned: boolean;
  contractPdfUrl?: string | null;
  createdBy?: string | null;
  createdAt: string;
  updatedAt: string;
  /** Slip or dry dock location name (e.g. "A-12") */
  slipName?: string | null;
}

/**
 * Create lease request
 */
export interface CreateLeaseRequest {
  customerId: string;
  vesselId: string;
  slipId: string;
  termType?: string | null;
  startDate: string;
  endDate?: string | null;
  monthlyRate: number;
  taxRate?: number | null;
  depositAmount: number;
  paymentFrequency?: string | null;
  dueDay?: number | null;
  lateFeePercent?: number | null;
  gracePeriodDays?: number | null;
  renewalNoticeDays?: number | null;
  terminationNoticeDays?: number | null;
  autoRenew: boolean;
  insuranceVerified: boolean;
  stormAddendumSigned: boolean;
  createdBy?: string | null;
}

/**
 * Update lease request
 */
export interface UpdateLeaseRequest {
  customerId?: string | null;
  vesselId?: string | null;
  slipId?: string | null;
  termType?: string | null;
  startDate?: string | null;
  endDate?: string | null;
  monthlyRate?: number | null;
  taxRate?: number | null;
  depositAmount?: number | null;
  paymentFrequency?: string | null;
  dueDay?: number | null;
  lateFeePercent?: number | null;
  gracePeriodDays?: number | null;
  renewalNoticeDays?: number | null;
  terminationNoticeDays?: number | null;
  autoRenew?: boolean | null;
  insuranceVerified?: boolean | null;
  stormAddendumSigned?: boolean | null;
  contractPdfUrl?: string | null;
}

